import React, { useContext } from 'react';

import Link from 'next/link';
import { LocaleContext } from 'Components/hooks/context';
import { component } from './styles.module.scss';
import getLanguage from 'Utils/getLocales/getLanguage';

const getLink = (locale, activeLocale) => {
  return locale === 'en' ? (
    <Link href='/' as='/' key={locale}>
      <a
        className={activeLocale === locale ? 'active' : ''}
      >{getLanguage(locale)}
      </a>
    </Link>
  ) : (
    <Link href='/[locale]' as={`/${locale}/`} key={locale}>
      <a
        className={activeLocale === locale ? 'active' : ''}
      >{getLanguage(locale)}
      </a>
    </Link>
  );
};

const LocaleLinks = ({ locales }) => {
  const activeLocale = useContext(LocaleContext);
  if (!locales.includes('en')) locales.unshift('en');

  const links = locales.map(locale => getLink(locale, activeLocale));

  return (
    <div className={`${component} font-sans`}>
      {links}
    </div>
  );
};

export default LocaleLinks;
